/// <reference path="skyward.base.global.js"/>
/// <reference path="skyward.ui.window.js"/>
/// <reference path="skyward.ui.events.js"/>
/// <reference path="skyward.ui.modallayer.js"/>
/// <reference path="skyward.ui.browse.js"/>

(
    function (skyward, $, undefined)
    {
        skyward.gradebookanalytics = skyward.gradebookanalytics || {};

        var init = function (selector)
        {
            $(selector).find(".categoryWeightInformationButton").on("click", function ()
            {
                var button = $(this);
                var buttonData = button.data();

                var title = buttonData.categoryCode + " Weight Information";
                var message = "<div class='categoryWeightInfoDiv'>Default Category Weight: <span>" + buttonData.defaultCategoryWeight + "</span></div>"
                            + "<div class='categoryWeightInfoDiv'>Adjusted Category Weight: <span>" + buttonData.adjustedCategoryWeight + "</span></div>"
                            + "<div class='categoryWeightInfoDiv'>Percent Earned: <span>" + buttonData.percentEarned + "</span></div>"
                            + "<div class='categoryWeightInfoDiv'>Adjusted Weight Formula: <span>" + buttonData.adjustedWeightFormula + "</span></div>"
                            + "<div class='boldFont'>" + "** Rounded formula may not accurately reflect actual calculation." + "</div>";

                var options =
                {
                    anchorTo: button
                };
                skyward.modalLayer.showInformationDialog(title, message, null, options);
            });
       
            $(selector).find(".gradeWeightInformationButton").on("click", function ()
            {
                var button = $(this);
                var buttonData = button.data();

                var title = "Grade Information";
                var message = "";

                var roundBucketPercent = buttonData.roundBucketPercent.toString().toLowerCase() == "true";
                var capCategoryAtHundred = buttonData.capCategoryAtHundred.toString().toLowerCase() == "true";
                var useSnapshot = buttonData.useSnapshot.toString().toLowerCase() == "true";

                if (buttonData.isAdminOverride.toString().toLowerCase() == "true")
                {
                    message += "<div class='categoryWeightInfoDiv'><span>This grade has been overridden by administration.  The grade mark has been updated, but the percentage remains unchanged.</span></div>";
                }
                else if (roundBucketPercent || capCategoryAtHundred || useSnapshot)
                {
                    message += roundBucketPercent ? "<div class='categoryWeightInfoDiv'><span>This grade has been rounded.</span></div>" : "";
                    message += capCategoryAtHundred ? "<div class='categoryWeightInfoDiv'><span>The categories weighted toward this grade have been capped at 100%.</span></div>" : "";
                    message += useSnapshot ? "<div class='categoryWeightInfoDiv'><span> This grade is a snapshot from " + buttonData.snapshotDate + "</span></div>" : "";
                }
                else
                {
                    message += "<div class='categoryWeightInfoDiv'>Original Grade: <span>" + buttonData.gradeMarkCode + " / " + buttonData.percent + "</span></div>";
                    message += buttonData.percentAdjustment != "" ? "<div class='categoryWeightInfoDiv'>Percent Adjustment: <span>" + buttonData.percentAdjustment + "</span></div>" : "";
                    message += buttonData.percentAdjustmentComment != "" ? "<div class='categoryWeightInfoDiv'>Percent Adjustment Comment: <span>" + buttonData.percentAdjustmentComment + "</span></div>" : "";
                    message += buttonData.gradeMarkOverrideCode != "" ? "<div class='categoryWeightInfoDiv'>Grade Mark Override: <span>" + buttonData.gradeMarkOverrideCode + "</span></div>" : "";
                    message += buttonData.gradeMarkOverrideComment != "" ? "<div class='categoryWeightInfoDiv'>Grade Mark Override Comment: <span>" + buttonData.gradeMarkOverrideComment + "</span></div>" : "";
                }
                var options =
                {
                    anchorTo: button
                };
                skyward.modalLayer.showInformationDialog(title, message, null, options);
            });

            var analyticsBrowse = $(selector).find(".analyticsBrowse");

            if (analyticsBrowse.length == 0)
            {
                return;
            }

            var getNextDescendingState = function (cell)
            {
                var sortSpanData = cell.find(".browseColumnSortSpan").data();
                var curentSortState = sortSpanData.descending;

                //descending toggle cycle: null -> sort (not descending) -> sort (descending) -> null
                if (curentSortState == null)
                {
                    return  false;
                }
                else if (curentSortState.toString().toLowerCase() == "false")
                {
                    return  true;
                }
                else if (curentSortState.toString().toLowerCase() == "true")
                {
                    return  null;
                }

                return null;
            };

            analyticsBrowse.on("click", ".categoryAverageCell", function ()
            {
                var browseName = "CategoryAnalytics";
                var cell = $(this);
                var cellData = cell.data();
                var browseData = $("#" + browseName).data();
                var action = browseData.isTeacherTracker.toString().toLowerCase() == "true" ? "StudentCategoryBreakdownTeacherTracker" : "StudentCategoryBreakdown";

                skyward.window.loadContent("full", "Grading", "StudentGradeBucket", action, cellData.studentGradeBucketId + "/" + cellData.categoryId);
            });

            analyticsBrowse.on("click", ".categoryAnalyticsBucketHeader", function ()
            {
                var browseName = "CategoryAnalytics";
                var cell = $(this);
                var cellData = cell.data();
                var descending = getNextDescendingState(cell);

                var browseData = $("#" + browseName).data();
                var data =
                {
                    teacherSectionGradeBucketAnalyticsSettingID: cellData.teacherSectionGradeBucketAnalyticsSettingId,
                    categoryID: cellData.categoryId,
                    descending: descending,
                    isTeacherTracker: browseData.isTeacherTracker
                };

                var action = browseData.isTeacherTracker.toString().toLowerCase() == "true" ? "UpdateCategoryAnalyticsSortTeacherTracker" : "UpdateCategoryAnalyticsSort";

                $.ajax(
                {
                    url: skyward.global.virtualDir + "Gradebook/GradebookAnalytics/" + action,
                    type: "POST",
                    dataType: "JSON",
                    data: data,
                    success: function ()
                    {
                        var browse = skyward.browse.browseList[browseName];
                        skyward.browse.get(browseName, { seekId: browse.seekid });
                    }
                });
            });

            analyticsBrowse.on("click", ".gradeAnalyticsCell", function ()
            {
                var cell = $(this);
                var cellData = cell.data();
                var browseData = cell.parents(".analyticsBrowse").data();

                skyward.window.loadContent("full", "Grading", "StudentGradeBucket", browseData.isTeacherTracker.toString().toLowerCase() == "true" ? "GradeAnalyticsBreakdownTeacherTracker" : "GradeAnalyticsBreakdown", cellData.studentGradeBucketId);
            });

            analyticsBrowse.on("click", ".gradeAnalyticsBucketHeader", function ()
            {
                var browseName = $(this).parents(".analyticsBrowse").attr("id");
                var cell = $(this);
                var cellData = cell.data();
                var descending = getNextDescendingState(cell);

                var browseData = $("#" + browseName).data();
                var data =
                {
                    calculationGroupGradeBucketId: cellData.calculationGroupGradeBucketId,
                    descending: descending,
                    isTeacherTracker: browseData.isTeacherTracker,
                    browseName: browseName
                };

                var action = browseData.isTeacherTracker.toString().toLowerCase() == "true" ? "UpdateGradeAnalyticsSortTeacherTracker" : "UpdateGradeAnalyticsSort";
                $.ajax(
                {
                    url: skyward.global.virtualDir + "Gradebook/GradebookAnalytics/" + action,
                    type: "POST",
                    dataType: "JSON",
                    data: data,
                    success: function ()
                    {
                        var browse = skyward.browse.browseList[browseName];
                        skyward.browse.get(browseName, { seekId: browse.seekid });
                    }
                });
            });

            analyticsBrowse.on("click", ".assignmentAnalyticsBucketHeader", function ()
            {
                var browseName = $(this).parents(".analyticsBrowse").attr("id");
                var cell = $(this).parent("td");
                var cellData = cell.data();
                var descending = getNextDescendingState(cell);

                var browseData = $("#" + browseName).data();
                var data =
                {
                    assignmentId: cellData.assignmentId,
                    descending: descending,
                    isTeacherTracker: browseData.isTeacherTracker,
                    browseName: browseName
                };

                var action = browseData.isTeacherTracker.toString().toLowerCase() == "true" ? "UpdateGradeAnalyticsAssignmentSortTeacherTracker" : "UpdateGradeAnalyticsAssignmentSort";
                $.ajax(
                {
                    url: skyward.global.virtualDir + "Gradebook/GradebookAnalytics/" + action,
                    type: "POST",
                    dataType: "JSON",
                    data: data,
                    success: function () {
                        var browse = skyward.browse.browseList[browseName];
                        skyward.browse.get(browseName, { seekId: browse.seekid });
                    }
                });
            });

            analyticsBrowse.on("click", ".browseColumnInfoSpan", function (event)
            {
                var button = $(this);
                var cell = button.closest("td");
                var cellData = cell.data();
                var browseName = button.parents(".analyticsBrowse").attr("id");
                var browseData = $("#" + browseName).data();

                var html = "<fieldset><label class='title'>Assigned Date</label><input class='assignmentDetailsPopupInput' type='text' readonly='readonly' value='" + cellData.assignedDate + "'/></fieldset>";
                html += "<fieldset><label class='title'>Due Date</label><input class='assignmentDetailsPopupInput' type='text' readonly='readonly' value='" + cellData.dueDate + "'/></fieldset>";
                html += "<fieldset><label class='title'>Category</label><input class='assignmentDetailsPopupInput' type='text' readonly='readonly' value='" + cellData.categoryCode + "'/></fieldset>";
                html += "<fieldset><label class='title'>Name</label><input class='assignmentDetailsPopupInput' type='text' readonly='readonly' style='width: 25em;' value='" + cellData.name + "'/></fieldset>";
                html += "<fieldset><label class='title'>Description</label><textarea class='assignmentDetailsPopupInput' type='text' readonly='readonly' style='width: 25em;'>" + cellData.description + "</textarea></fieldset>";
                html += "<fieldset><label class='title'>Max Score</label><input class='assignmentDetailsPopupInput' type='text' readonly='readonly' value='" + cellData.maxScore + "'/></fieldset>";
                html += "<fieldset><label class='title'>Weight</label><input class='assignmentDetailsPopupInput' type='text' readonly='readonly' value='" + cellData.weight + "'/></fieldset>";

                var createButton = browseData.isTeacherTracker.toString().toLowerCase() == "true" || cellData.hasAssignmentDetailsPermission.toLowerCase() == "false" ? null :
                {
                    text: "Open Assignment Details", click: function ()
                    {
                        skyward.window.loadContent("popout", "Gradebook", "Assignment", browseData.isTeacherTracker.toString().toLowerCase() == "true" ? "DetailsTeacherTracker" : "Details", cellData.assignmentId);
                    }, icon: "RowOpen"
                };

                var closeButton = { text: "Close", click: function () { dialog.close(); }, icon: "Close" };
                var options =
                {
                    anchorTo: button
                };
                var dialog = skyward.modalLayer.showDialog('Assignment Information', html, [createButton, closeButton], options);
                
                event.preventDefault();
                event.stopPropagation();
            });
        };

        var selectGradeBucketsToDisplay = function ()
        {
            var clickedElement = $(this);
            var browseElement = clickedElement.parents(".browse");
            var browseData = browseElement.data();
            browseData.requestedFromBrowseName = browseElement.attr("id");

            var action = browseData.isTeacherTracker.toString().toLowerCase() == "true" ? "BuildGradeBucketsToDisplayPopupTeacherTracker" : "BuildGradeBucketsToDisplayPopup";

            var buildPopup = function ()
            {
                return $.ajax({
                    url: skyward.global.virtualDir + "Gradebook/GradebookAnalytics/" + action,
                    type: "POST",
                    dataType: "viewparthtml",
                    data: browseData,
                    success: function ()
                    {
                        if (browseData.requestedFromBrowseName == "AssignmentAnalytics")
                        {
                            var browseLoadedEvent = "browseLoaded.CalculationGroupGradeBucketsToDisplay";
                            $("body").off(browseLoadedEvent).on(browseLoadedEvent, assignmentAnalyticsPrepGradeBucketSelectionBrowse);
                        }
                    }
                });
            };

            var saveGradeBucketAnalyticsDisplaySettings = function ()
            {
                $(this).off("click", saveGradeBucketAnalyticsDisplaySettings);

                var data =
                {
                    teacherSectionSettingId: browseData.teacherSectionSettingId,
                    sectionId: browseData.sectionId,
                    SectionIDHash: browseData.sectionIdHash,
                    isTeacherTracker: browseData.isTeacherTracker,
                    requestedFromBrowseName: browseData.requestedFromBrowseName
                };

                var cggbToDisplayBrowse = $("#CalculationGroupGradeBucketsToDisplay");
                data.browseSaveData = JSON.stringify(cggbToDisplayBrowse.data().editablebrowsedata);

                var saveAction = browseData.isTeacherTracker.toString().toLowerCase() == "true" ? "SaveAnalyticsGradeBucketsToDisplayTeacherTracker" : "SaveAnalyticsGradeBucketsToDisplay";

                $.ajax(
                {
                    url: skyward.global.virtualDir + "Gradebook/GradebookAnalytics/" + saveAction,
                    type: "POST",
                    dataType: "JSON",
                    data: data,
                    success: function (returnData)
                    {
                        $(this).on("click", saveGradeBucketAnalyticsDisplaySettings);

                        if (returnData.success)
                        {
                            dialog.close();
                            var browseElementID = browseElement.attr("id");
                            var browse = skyward.browse.browseList[browseElementID];
                            skyward.browse.get(browseElementID, { seekId: browse.seekid });
                        }
                        else
                        {
                            var container = $('.messageBox.content');
                            var baseErrorContainer = container.find(".contentBaseError");

                            skyward.validation.displayValidationMessages(returnData, container, baseErrorContainer);
                        }
                    }
                });
            };

            var saveButton = { text: "Save", click: saveGradeBucketAnalyticsDisplaySettings, icon: "Save" };
            var cancelButton = { text: "Cancel", click: function () { dialog.close(); }, icon: "Cancel" };

            var dialog = skyward.modalLayer.showDialog("Grade Columns To Display", buildPopup, [ saveButton, cancelButton ]);
        };

        var selectCategoriesToDisplay = function ()
        {
            var clickedElement = $(this);
            var browseElement = clickedElement.parents(".browse");
            var browseData = browseElement.data();
            browseData.requestedFromBrowseName = browseElement.attr("id");

            var action = browseData.isTeacherTracker.toString().toLowerCase() == "true" ? "BuildCategoriesToDisplayPopupTeacherTracker" : "BuildCategoriesToDisplayPopup";

            var buildPopup = function ()
            {
                return $.ajax({
                    url: skyward.global.virtualDir + "Gradebook/GradebookAnalytics/" + action,
                    type: "POST",
                    dataType: "viewparthtml",
                    data: browseData
                });
            };

            var saveAnalyticsCategoriesToDisplaySettings = function ()
            {
                $(this).off("click", saveAnalyticsCategoriesToDisplaySettings);

                var data =
                {
                    teacherSectionSettingId: browseData.teacherSectionSettingId,
                    sectionId: browseData.sectionId,
                    sectionIDHash: browseData.sectionIdHash,
                    isTeacherTracker: browseData.isTeacherTracker,
                    requestedFromBrowseName: browseData.requestedFromBrowseName
                };

                var cggbToDisplayBrowse = $("#CategoriesToDisplay");
                data.browseSaveData = JSON.stringify(cggbToDisplayBrowse.data().editablebrowsedata);

                var saveAction = browseData.isTeacherTracker.toString().toLowerCase() == "true" ? "SaveAnalyticsCategoriesToDisplaySettingsTeacherTracker" : "SaveAnalyticsCategoriesToDisplaySettings";

                $.ajax(
                {
                    url: skyward.global.virtualDir + "Gradebook/GradebookAnalytics/" + saveAction,
                    type: "POST",
                    dataType: "JSON",
                    data: data,
                    success: function (returnData)
                    {
                        $(this).on("click", saveAnalyticsCategoriesToDisplaySettings);

                        if (returnData.success)
                        {
                            dialog.close();
                            var browseElementID = browseElement.attr("id");
                            var browse = skyward.browse.browseList[browseElementID];
                            skyward.browse.get(browseElementID, { seekId: browse.seekid });
                        }
                        else
                        {
                            var container = $('.messageBox.content');
                            var baseErrorContainer = container.find(".contentBaseError");

                            skyward.validation.displayValidationMessages(returnData, container, baseErrorContainer);
                        }
                    }
                });
            };

            var saveButton = { text: "Save", click: saveAnalyticsCategoriesToDisplaySettings, icon: "Save" };
            var cancelButton = { text: "Cancel", click: function () { dialog.close(); }, icon: "Cancel" };

            var dialog = skyward.modalLayer.showDialog("Categories To Display", buildPopup, [saveButton, cancelButton]);
        };

        var assignmentAnalyticsPrepGradeBucketSelectionBrowse = function ()
        {
            $("#CalculationGroupGradeBucketsToDisplay").find("input:checkbox").each(function ()
            {
                selectGradeBucketsGetInnerCalculationGroupGradeBuckets.apply($(this));
            });

            $("#CalculationGroupGradeBucketsToDisplay").off("change", "input:checkbox", selectGradeBucketsGetInnerCalculationGroupGradeBuckets).on("change", "input:checkbox", selectGradeBucketsGetInnerCalculationGroupGradeBuckets);
        };

        var selectGradeBucketsGetInnerCalculationGroupGradeBuckets = function ()
        {
            var clickedElement = $(this);
            var clickedElementData = clickedElement.data();

            var browseElement = clickedElement.parents(".browse");

            var enableCheckbox = function (innerCheckbox)
            {
                var calculationGroupGradeBucketID = innerCheckbox.attr("id").split("-")[1];

                var disableRequired = false;
                //Foreach checkbox in browse, check if there are any checkboxes with inner grade buckets that match the one passed in. If an inner bucket matches and the checkbox is checked its still required
                browseElement.find("input:checkbox").each(function ()
                {
                    var checkbox = $(this);
                    var checkboxData = checkbox.data();

                    if (checkboxData.innerCalculationGroupGradeBucketIds)
                    {
                        $.each(checkboxData.innerCalculationGroupGradeBucketIds, function (index, value)
                        {
                            if (value == calculationGroupGradeBucketID)
                            {
                                if (checkbox.is(":checked"))
                                {
                                    disableRequired = true;
                                    return;
                                }
                            }
                        });
                    }
                });

                return !disableRequired;
            };

            if (!clickedElementData.innerCalculationGroupGradeBucketIds)
            {
                return;
            }

            $.each(clickedElementData.innerCalculationGroupGradeBucketIds, function (index, value)
            {
                var innerCheckbox = $("#DisplayCalculationGroupGradeBucket-" + value);
                if (!clickedElement.is(":checked") && enableCheckbox(innerCheckbox))
                {
                    skyward.controls.enable(innerCheckbox);
                }
                else
                {
                    skyward.controls.disable(innerCheckbox);
                    skyward.controls.setValue(innerCheckbox, true);
                }
            });
        };

        var assignmentIndicatorPopup = function ()
        {
            var button = $(this);
            var firstRow;
            var browse = button.parents(".analyticsBrowse");

            button.find('.assignmentIndicators').each(function ()
            {
                var span = $(this);
                if (span.hasClass('assignmentIndicatorsFirstRow'))
                {
                    firstRow = span;
                }
            });

            var assignmentCell = button.parents('.assignmentAnalyticsAssignmentCell ');
            var assignmentCellData = assignmentCell.data();

            var data =
            {
                studentSectionID: assignmentCellData.studentsectionid,
                assignmentID: assignmentCellData.assignmentid,
                showScoreWarning: !firstRow.hasClass('hiddenWarning'),
                sectionID: assignmentCellData.sectionid,
                sectionIDHash: assignmentCellData.sectionidhash
            };

            var buildPopup = function ()
            {
                var action = browse.data().isTeacherTracker.toString().toLowerCase() == "true" ? "AdvancedStudentAssignmentPopupTeacherTracker" : "AdvancedStudentAssignmentPopup";
                return $.ajax(
                {
                    url: skyward.global.virtualDir + "Gradebook/Gradebook/" + action,
                    type: "POST",
                    dataType: "viewparthtml",
                    data: data
                });
            };

            $.when(buildPopup()).done(function (html)
            {
                var cancelButton = { id: "cancelAdvancedStudentAssignmentPopup", text: "Cancel", click: function () { dialog.close(); }, icon: "Cancel" };

                var dialog = skyward.modalLayer.showDialog('Student Assignment Information', html, [cancelButton], { anchorTo: button });
            });
        };

        // Event handlers
        var events =
        {
            "selectCategoriesToDisplay": selectCategoriesToDisplay,
            "selectGradeBucketsToDisplay": selectGradeBucketsToDisplay,
            'assignmentIndicatorPopup': assignmentIndicatorPopup
        };
        skyward.events.registerEvents("gradebookAnalytics", events);

        //Bootstrap
        skyward.window.registerLoadDOMCallback(init);

    }(window.skyward = window.skyward || {}, window.jQuery)
);
